

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';
import { useMediaQuery } from 'react-responsive'

// Material helpers
import { NavLink, withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
// Material components
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Grid from '@material-ui/core/Grid';
//import Tooltip from '@material-ui/core/Tooltip';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import HelpIcon from '@material-ui/icons/Help';
import IconButton from '@material-ui/core/IconButton';
import StopIcon from '@material-ui/icons/Stop';
import Divider from '@material-ui/core/Divider';
import Popover from '@material-ui/core/Popover';
import UpdateIcon from '@material-ui/icons/Update';
import Avatar from '@material-ui/core/Avatar';
import {getObjectives} from '../../../../services/getObjectives'
import { reportFetchError } from '../../../../observability/rum';
import Hidden from '@material-ui/core/Hidden';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
// Component styles
import moment from 'moment-timezone'
import 'moment/locale/es'
import AvailabilityObjective from './AvailabilityObjective';
import FilterService from './Filter';
import {getAvailabilityObjetive} from './../../../../services/getAvailability'
import ListObjectiveModal from '../ListObjectiveModal';
import { FilterTags } from '../../../../components/TagsAtentus/FilterTags';
import queryString from 'query-string';
import { sidebarFiltersTags } from '../../../../utils/local-storage/sidebar-options';
import { Box, Dialog } from '@material-ui/core';
import Filter from '../../../../helpers/Filter'
import { withTranslation } from 'react-i18next';
moment.locale('es')


class FastView extends Component {
    constructor(props) {
        super(props);
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        const parsed = queryString.parse(props.location.search);
        const etiquetas = parsed?.etiquetas && parsed?.etiquetas !== '' ?
            parsed?.etiquetas.split('T').map(e => Number(e)) ?? [] : [];
        const services = parsed?.services && parsed?.services !== '' ?
            parsed?.services?.split(',') ?? [] : [];        
        const filterTypeFromStorage = sidebarFiltersTags.getFilterType();
        const filterTagsType = parsed?.filterTagsType ?? filterTypeFromStorage;
        const status = parsed?.filterType ?? t('fastview.status-list.0');

        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        sessionStorage.setItem("listsLoads",false)
        this.handleInfoAutoComplete = this.handleInfoAutoComplete.bind(this);
        this.state = {
            load:true,
            loadError:false,
            listObjectives:{},
            listAllObjectivesActives:[],
            listDowntime:{},
            listUptime:{},
            listPartial:{},
            listNoMonPartial:{},
            newList:[],
            maxSteps:0,
            dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")),
            filtro:false,
            isInfo:null,
            open: false,
            objNameModal: '',
            fromBoards: sessionStorage.getItem('fromBoards') === 'true',
            intervalId: null,
            filterTagsId: etiquetas,
            filterServices: services,
            filterTagsType: filterTagsType,
            stateFilter: status,
            stateFilterIndex: 0
        };   
    }
    tick=()=>{
        window.location.reload()
        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        sessionStorage.setItem("listsLoads",false)
        this.setState({
            load:true,
            listObjectives:{},
            listAllObjectivesActives:[],
            listDowntime:{},
            listUptime:{},
            listPartial:{},
            listNoMonPartial:{},
            newList:[],
            maxSteps:0,
            counter:0,
            dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")),
            filtro:false,
            isInfo:null,
            
        })
        this.processData()
      }
    componentDidMount() {
        sessionStorage.setItem('fromBoards', false)
        this.processData()
        const newInterval = setInterval(
            () => this.tick(),
            900000
        )
        this.setState({intervalId: newInterval})
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }

    componentDidUpdate(prevProps, prevState) {
        /* CUANDO LISTA OBTIENE DISPONIBILIDAD EN TODOS LOS OBJETIVOS VUELVE A LLAMAR A PROCESS*/
        if(this.state.newList && this.state.listAllObjectivesActives && this.state.newList.length!==0 && this.state.newList.length===this.state.listAllObjectivesActives.length ){
            this.processData()
        }
        if (this.props.t !== prevProps.t) {
            const queryParamsParsed = queryString.parse(document.location.search);
            queryParamsParsed["etiquetas"] = this.state.filterTagsId.join("T");
            queryParamsParsed["services"] = this.state.filterServices.join(",");
            queryParamsParsed["filterType"] = this.props.t('fastview.status-list.'+this.state.stateFilterIndex);
            queryParamsParsed['filterTagsType'] = this.state.filterTagsType;
            window.history.replaceState(
                null,
                "Vista rápida",
                `/quickview?${queryString.stringify(
                    queryParamsParsed,                
                )}`
            );
            this.setState({ stateFilter: this.props.t('fastview.status-list.'+this.state.stateFilterIndex)});
        }
    }
    /*FUNCION QUE LLAMA DISPONIBILIDAD*/
    getFetchs = (objectiveParams, user, token) =>{
        return new Promise(resolve => {
            setTimeout(() => {
                getAvailabilityObjetive(objectiveParams.objetivo_id, 'h', user, token).then(data => {
                    //SE ESTABLECE DISPONIBILIDAD GLOBAL
                    objectiveParams["disponibilidad"]=parseFloat((data.data.uptime+data.data.parcial+data.data["no monitoreo"]+data.data['evento_cliente']+data.data['marcado_atentus']).toFixed(2))
                    resolve(objectiveParams);
                })
                .catch((error) => {
                    reportFetchError('FastView', error)
                    resolve(objectiveParams);
                })
                
            }, 1);
        });
    }
    processData = () => {
        const {newList, listAllObjectivesActives, listObjectives, maxSteps}=this.state
        var countPasos=0
        if(sessionStorage.getItem("listsLoadsDisponibilidad")==="true"){
            var listaObjetivosOnlineDisponibilidad=JSON.parse(sessionStorage.getItem("listaObjetivosOnlineDisponibilidad"))
            if(maxSteps!==0){
                countPasos=maxSteps
            }else{
                Object.keys(listaObjetivosOnlineDisponibilidad).map(ele=>{
                    (listaObjetivosOnlineDisponibilidad[ele]).map(obj=>{
                        var Pasos=(obj.Pasos.length)
                        if(Pasos>countPasos){
                            countPasos=Pasos
                        }
                    })
                })
            }
            this.setState({
                listObjectives:listaObjetivosOnlineDisponibilidad,
                listDowntime:listaObjetivosOnlineDisponibilidad.Downtime,
                listUptime:listaObjetivosOnlineDisponibilidad.Uptime,
                listPartial:listaObjetivosOnlineDisponibilidad.Partial,
                listNoMonPartial:listaObjetivosOnlineDisponibilidad.NoMonitoringPartial,
                load:false,
                maxSteps:countPasos,
                newList:[],
                
            })
        }else{
            //console.log('sin cache de disponibilidad')
            /*UNA VEZ QUE PASA POR TODOS LOS OBJETIVOS TRAYENDO DISPONIBILIDAD*/
            if( this.state.newList && this.state.listAllObjectivesActives && newList.length!==0 && newList.length===listAllObjectivesActives.length){
                Object.keys(listObjectives).map(key=>{
                    Object.keys(listObjectives[key]).map(ele=>{
                        newList.map(newEle=>{
                            if(newEle.objetivo_id===listObjectives[key][ele].objetivo_id){
                                var Pasos=(newEle.Pasos.length)
                                if(Pasos>countPasos){
                                    countPasos=Pasos
                                }
                                if(newEle.estado==="No monitoreo"){
                                    newEle.disponibilidad=0
                                }
                                listObjectives[key][ele]=newEle
                            }
                        })
                    })
                    listObjectives[key].sort(function (a, b) {
                        return (a.disponibilidad - b.disponibilidad);
                    });
                })
                sessionStorage.setItem("listaObjetivosOnlineDisponibilidad",JSON.stringify(listObjectives))
                sessionStorage.setItem("listsLoadsDisponibilidad",true)
                this.setState({
                    listObjectives:listObjectives,
                    listDowntime:listObjectives.Downtime,
                    listUptime:listObjectives.Uptime,
                    listPartial:listObjectives.Partial,
                    listNoMonPartial:listObjectives.NoMonitoringPartial,
                    maxSteps:countPasos,
                    load:false,
                    newList:[],
                    //counter:0
                })
            }else{
                //console.log('listas distintas')
                var user=sessionStorage.getItem("user")
                var token=sessionStorage.getItem("key")
                const allowed = ['Uptime', 'Downtime', 'Partial', 'NoMonitoringPartial']
                var filtered={}
                var listAllActive={}
                //OBTIENE LISTA DE OBJETIVOS DESDE SESSION O VA A BUSCAR
                if(sessionStorage.getItem("listsLoads")==="true"){
                    //console.log('hay session globales ')
                    var raw =JSON.parse(sessionStorage.getItem("listaData"))
                    //console.log(raw)
                    var actives=JSON.parse(sessionStorage.getItem("listaDataActive"))
                    listAllActive=actives
                    //filtered= Object.keys(raw).filter(key => allowed.includes(key)).reduce((obj, key) => {obj[key] = raw[key];return obj;}, {});
                    filtered={"Uptime":raw.Uptime, "Partial":raw.Partial, "NoMonitoring": raw.NoMonitoring, "Downtime":raw.Downtime, "NoMonitoringPartial": raw.NoMonitoringPartial}
                    //console.log(filtered)
                    Object.keys(filtered).map(key=>{
                        filtered[key].map(objectiveParams=>{
                            if(objectiveParams.estado!=="No monitoreo"){
                                var data =this.getFetchs(objectiveParams, user, token)
                                data.then( value=>{
                                    if(objectiveParams.objetivo_id===value.objetivo_id){
                                        objectiveParams=value
                                        this.setState(data=>({
                                            newList:[...data.newList, value]
                                        }))
                                    }
                                })
                            }else{
                                this.setState(data=>({
                                    newList:[...data.newList, objectiveParams]
                                }))
                            }
                        }) 
                    })
                    this.setState({
                        listObjectives:filtered,
                        listAllObjectivesActives:listAllActive
                    })
                }else{
                    //console.log('sin session global')
                    let token = sessionStorage.getItem('key')
                    let user_id = sessionStorage.getItem('user')
                    //console.log('carga sin cache de objetivos globales vista rapida')

                    /*OBTIENE OBJETIVOS POR ESTADO*/
                    getObjectives(user_id, token).then(data=>{
                        //console.log(data)
                        if (data.status === 1 || data.status === 5) {
                            localStorage.setItem('isAuthenticated', false);   
                        } else {
                            let dataSeries = []
                            let dataServices = []
                            let checked = []
                            let actives=[]
                            dataServices.push('Todos')
                            checked.push(0)
                            Object.keys(data).map((keyType) => {
                                if (keyType != 'Services' && keyType != 'ServicesUnified') {
                                    let serie = data[keyType]
                                    Object.keys(serie).map((key) => {
                                        serie[key].nombre=(serie[key].nombre.replaceAll("/", "|"))
                                        dataSeries.unshift(serie[key])
                                        actives.unshift(serie[key])
                                    })
                                } else if (keyType == 'ServicesUnified') {                            
                                    let serie = data[keyType]
                                    Object.keys(serie).map((key) => {
                                        checked.push(parseInt(key)+1)
                                        dataServices.push(serie[key])
                                    })
                                }
                            })
                            //console.log('process vr data', dataSeries)
                            actives.sort(function (a, b) {
                                return (a.orden - b.orden);
                            });
                            dataSeries.sort(function (a, b) {
                                return (a.orden - b.orden);
                            });
                            listAllActive=actives
                            sessionStorage.setItem("listaData",JSON.stringify(data))
                            sessionStorage.setItem("listaDataActive",JSON.stringify(actives))
                            sessionStorage.setItem("listaObjetivosOnline",JSON.stringify(dataSeries))
                            sessionStorage.setItem("dataServices",JSON.stringify(dataServices))
                            sessionStorage.setItem("checked",JSON.stringify(checked))
                            sessionStorage.setItem("listsLoads",true)
                            var raw=data
                            //{Uptime: Array(8), Partial: Array(0), Downtime: Array(3)}//
                            filtered={"Uptime":data.Uptime, "Partial":data.Partial, "NoMonitoring": data.NoMonitoring, "Downtime":data.Downtime, "NoMonitoringPartial": data.NoMonitoringPartial}
                            //filtered = Object.keys(raw).filter(key => allowed.includes(key)).reduce((obj, key) => {obj[key] = raw[key];return obj;}, {});
                            Object.keys(filtered).map(key=>{
                                filtered[key].map(objectiveParams=>{
                                    if(objectiveParams.estado!=="No monitoreo"){
                                        var data =this.getFetchs(objectiveParams, user, token)
                                        data.then( value=>{
                                            if(objectiveParams.objetivo_id===value.objetivo_id){
                                                objectiveParams=value
                                                try{
                                                    this.setState(data=>({
                                                        newList:[...data.newList, value]
                                                    }))
                                                } catch (e) {
                                                    console.log('e', e)
                                                    
                                                } 
                                            }
                                        })
                                    }else{
                                        this.setState(data=>({
                                            newList:[...data.newList, objectiveParams]
                                        }))
                                    }
                                    //console.log("1", this.state.newList)
                                }) 
                            })
                            //console.log(listAllActive)
                            this.setState({
                                listObjectives:filtered,
                                listAllObjectivesActives:listAllActive,
                            })
                        }
                    })
                    .catch((error) => {
                        reportFetchError('FastView', error)
                        this.setState({ load: false, loadError: true })
                    })
                }
            }
        }
    }

    handleInfoAutoComplete(info) {
        const services = info.map(({servicio}) => servicio);
        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["etiquetas"] = this.state.filterTagsId.join("T");
        queryParamsParsed["services"] = services.join(",");
        queryParamsParsed["filterType"] = this.state.stateFilter;
        queryParamsParsed['filterTagsType'] = this.state.filterTagsType;
        window.history.replaceState(
            null,
            "Vista rápida",
            `/quickview?${queryString.stringify(
                queryParamsParsed,                
            )}`
        );
        this.setState({filterServices: services});
    }


    handleChangeStateFilter = (e, item) => {
        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["etiquetas"] = this.state.filterTagsId.join("T");
        queryParamsParsed["services"] = this.state.filterServices.join(",");
        queryParamsParsed["filterType"] = item.nombre;
        queryParamsParsed['filterTagsType'] = this.state.filterTagsType;
        window.history.replaceState(
            null,
            "Vista rápida",
            `/quickview?${queryString.stringify(
                queryParamsParsed,                
            )}`
        );
        this.setState({ stateFilter: item.nombre, stateFilterIndex: item.id });
    }
    

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };
    handleRetry = () => {
        this.setState({
            load: true,
            loadError: false
        }, this.processData);
    };

    handleOpen = event => {       
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value
        //console.log(objId, objName, this.state.open)
            this.setState({
                open: true,
                objIdModal: objId,
                objNameModal: objName
            })      
    };
    
    handleClose = event => {
        //const newStep = event.currentTarget.id
        this.setState({
            open: false,
        })
    };

    updateEtiquetas = (etiquetas, filterType) => {
        const ids = etiquetas.map(etiqueta => etiqueta.etiqueta_id)
        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["etiquetas"] = ids.join("T");
        queryParamsParsed["services"] = this.state.filterServices.join(",");
        queryParamsParsed["filterType"] = this.state.stateFilter;
        queryParamsParsed['filterTagsType'] = filterType;
        window.history.replaceState(
            null,
            "Vista rápida",
            `/quickview?${queryString.stringify(
                queryParamsParsed,                
            )}`
        );
        this.setState({filterTagsId: ids, filterTagsType: filterType})
    }

    objectivesListFilteredByTags = () => {  
        const listWithoutNoMonPartial = Object.assign({}, this.state.listObjectives)
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        delete listWithoutNoMonPartial.NoMonitoringPartial 
        if (this.state.filterTagsId.length === 0 && this.state.filterServices.length === 0 && this.state.stateFilter === t('fastview.status-list.0')) return listWithoutNoMonPartial
        const newListObjectives = {}
        let filterState = 
            this.state.stateFilter === t('fastview.status-list.5') ? 'NoMonitoring' :
            this.state.stateFilter === t('fastview.status-list.6') ? 'NoMonitoringPartial' :
            this.state.stateFilter === t('fastview.status-list.3') ? 'Partial' : 
            this.state.stateFilter
        for (const state in this.state.listObjectives) {   
            if (filterState === t('fastview.status-list.0') || state === filterState || (filterState === t('fastview.status-list.1') && state !== 'NoMonitoring' && state !== 'NoMonitoringPartial')) {  
                              
                const filtered = this.state.listObjectives[state].filter(obj => {
                    let tieneEtiquetas = true
    
                    if (this.state.filterTagsType === "AND") {
                        for (const id of this.state.filterTagsId) {
                            if (!obj.Etiquetas.find(et => et.etiqueta_id === id)) {
                                tieneEtiquetas = false
                                break;
                            }
                        }
                    } else {
                        tieneEtiquetas = obj.Etiquetas.filter(et => this.state.filterTagsId.includes(et.etiqueta_id)).length
                    }
                    
                    if (!this.state.filterServices.length && this.state.filterTagsId.length) {
                        return tieneEtiquetas > 0;
                    }
                    if (this.state.filterServices.length && !this.state.filterTagsId.length) {
                        return this.state.filterServices.includes(obj.nombre_servicio_unificado)
                    }
                    if (!this.state.filterServices.length && !this.state.filterTagsId.length) {
                        return true;
                    }
                    return tieneEtiquetas > 0 && this.state.filterServices.includes(obj.nombre_servicio_unificado)
                })
                newListObjectives[state] = filtered
            } else {
                newListObjectives[state] = []
            }
        }
        return newListObjectives
    }

    render() {
        const list = this.objectivesListFilteredByTags()
        const {load, loadError, listObjectives, maxSteps, dateMoment, isInfo, open,
            objIdModal,
            objNameModal, fromBoards} = this.state;
        const showIsInfo = Boolean(isInfo);
        //console.log('render fast', load)
        const { classes } = this.props;
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        const filterList = [
            { nombre: t('fastview.status-list.0'), id: 0},
            { nombre: t('fastview.status-list.1'), id: 1},
            { nombre: t('fastview.status-list.2'), id: 2},
            { nombre: t('fastview.status-list.3'), id: 3},
            { nombre: t('fastview.status-list.4'), id: 4},
            { nombre: t('fastview.status-list.5'), id: 5},
            { nombre: t('fastview.status-list.6'), id: 6},
        ];
        //console.log(downList)
        if (load===true) {
            //console.log('vista rapida render carga')
            return(
                <Grid style={{fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', height: '85px', fontSize: '14px', color: '#666666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                        <CircularProgress variant="indeterminate" size={24} thickness={4} />
                    </Grid>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                        {t('text.loading')}
                    </Grid>
                </Grid>
            )
        }else{
            //console.log('vista rapida render final', listObjectives)
            return(
                <Portlet>
                    <PortletHeader style={{borderBottom: "none", height: "auto"}}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent='space-between'
                            spacing={3}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                style={{marginTop: 20}}
                            >
                                <Box display='flex' justifyContent='end'>
                                    <Box display='flex' flexDirection='row' alignItems='center'>
                                        <IconButton
                                            onClick={this.handleShowIsInfo}
                                        >
                                            <HelpIcon style={{color:"#b9b9b9"}}/>
                                        </IconButton>
                                        <Hidden mdDown>
                                                <Avatar variant="rounded" className={classes.rounded}>
                                                    <UpdateIcon /> 
                                                </Avatar>
                                        </Hidden>
                                        <Hidden mdDown>
                                            <Typography noWrap  className={classes.updateTime} style={{textAlign:"left"}}  >
                                                    &nbsp; {t('text.last-update')}: {dateMoment} 
                                            </Typography>
                                        </Hidden>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid 
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={4}
                                xl={4}
                            >   
                                <FilterService
                                    InfoAutoComplete={this.handleInfoAutoComplete}
                                />
                                
                            </Grid>
                            <Grid 
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={4}
                                xl={4}
                            >   
                                <Filter
                                    list={filterList}
                                    label={t('text.select-status')}
                                    InfoAutoComplete={this.handleChangeStateFilter}
                                    placeholder={t('text.status')}
                                    default={this.state.stateFilter}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={4}
                                xl={4}
                            >
                                <div>
                                    <FilterTags
                                        listObjectives={listObjectives}
                                        updateEtiquetas={(etiqueta, filterType = "OR") => this.updateEtiquetas(etiqueta, filterType)}
                                        tagsId={this.state.filterTagsId}
                                        preload={true}
                                        filterTagsType={this.state.filterTagsType}
                                        showFilterType={true}
                                    />
                                </div>
                            </Grid>                            
                        </Grid>
                    </PortletHeader>
                    <PerfectScrollbar>
                    <PortletContent>
                        {loadError ?
                        <Box textAlign="center">
                            <Typography variant="h6">{t('text.load-error')}</Typography>
                            <Button color="primary" onClick={this.handleRetry}>{t('text.retry')}</Button>
                        </Box>
                        :
                        <Table >
                            <TableRow className={classes.tableRow}>

                                <TableCell className={classes.monitoreos} colSpan={2}>
                                    <Typography className={classes.headerTableText} style={{fontSize:"18px"}}>{t('quickview.tablehead.current-monitoring-status')}</Typography>
                                </TableCell>
                                <TableCell className={classes.stepAlign } colSpan={maxSteps}>
                                    <Typography className={classes.headerTableText} style={{fontSize:"18px"}} >{t('quickview.tablehead.current-step-status')}</Typography>
                                </TableCell>
                                <TableCell className={classes.Tendencia }>
                                    <Typography className={classes.headerTableText} style={{fontSize:"18px"}}>{t('quickview.tablehead.trend')}</Typography>
                                    <Typography className={classes.headerTableText} style={{fontSize:"15px"}}>{t('quickview.tablehead.trend.hour')}</Typography>
                                </TableCell>
                                <TableCell className={classes.alignRight}>
                                    <Typography className={classes.headerTableText} style={{fontSize:"18px"}}>{t('quickview.tablehead.global-availability')}</Typography>
                                    <Typography className={classes.headerTableText} style={{fontSize:"15px"}}>{t('quickview.tablehead.global-availability.hour')}</Typography>
                                </TableCell>
                            </TableRow>
                            <AvailabilityObjective data={list} maxSteps={maxSteps} handleOpen={this.handleOpen} handleClose={this.handleClose}/>
                        </Table>
                        }
                        <Popover
                            anchorEl={isInfo}
                            open={showIsInfo}
                            onClose={this.handleCloseIsInfo}
                            PaperProps={{
                                style: { width: 350 }
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                              }}
                            >
                            <PortletContent className={classes.popoverPorlet}>
                                <Grid style={{textAlign:"right"}} >
                                    <IconButton style={{color:'white'}} onClick={this.handleCloseIsInfo}><CloseIcon/></IconButton>
                                </Grid>
                                <Typography variant="body1" className={classes.textColorPopover} >{t('quickview.info.0')}
                                </Typography>
                                <Divider/>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    
                                    <StopIcon color="primary" /><Typography variant="body2" className={classes.textColorPopover}>{t('quickview.info.1')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopYellow} /><Typography variant="body2" className={classes.textColorPopover}>{t('quickview.info.2')}</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopGreen} /><Typography variant="body2" className={classes.textColorPopover}>{t('quickview.info.3')}</Typography>
                                </Grid>
                                <Divider/>
                                <Typography variant="body1" className={classes.textColorPopover}> 
                                    {t('quickview.info.4')} 
                                </Typography>
                            
                            </PortletContent>
                        </Popover>
                        <Dialog
                            maxWidth='lg'
                            fullWidth
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={open}
                            onClose={this.handleClose}
                            closeAfterTransition
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                            >                                    
                            <Fade in={open}>
                                <ListObjectiveModal obj={objIdModal} objName={objNameModal} listObjectives={listObjectives} handleClose={this.handleClose}/>                        
                            </Fade>
                        </Dialog>
                    </PortletContent>
                    </PerfectScrollbar>
                </Portlet>
            )
        }
    }
}


export default compose(withRouter, withStyles(styles), withTranslation())(FastView);
